import React from 'react';
import {classes} from './AsideSummary.st.css';
import {useControllerProps} from '../../Widget/ControllerContext';
import {SummaryLocation} from '../../../../types/checkoutApp.types';
import {TopMobileSummary} from '../TopMobileSummary/TopMobileSummary';
import {CartSummary} from '../CartSummary';
import {SecureCheckout} from '../../../../common/components/SecureCheckout/SecureCheckout';
import {CheckoutSlot} from '../../CheckoutSlot';
import {SlotId} from '../../../../domain/utils/slotId';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../../common/constants';

export enum SummaryDataHooks {
  couponSectionInput = 'SummaryDataHooks.couponSectionInput',
  giftCardSectionInput = 'SummaryDataHooks.giftCardSectionInput',
  violations = 'SummaryDataHooks.violations',
}

export interface SummaryProps {
  location: SummaryLocation;
  dataHook: string;
  checkboxesRef?: React.RefObject<HTMLDivElement>;
}

export const AsideSummary = ({dataHook}: SummaryProps) => {
  const {
    checkoutStore: {isFastFlow},
    isOneColumnView,
  } = useControllerProps();
  const {experiments} = useExperiments();
  const checkoutUIRevampOrderSummary = experiments.enabled(SPECS.CheckoutUIRevampOrderSummary);
  const shouldShowSlot = !isFastFlow;
  return (
    <div className={classes.root} data-hook={dataHook}>
      {isOneColumnView ? (
        <TopMobileSummary />
      ) : (
        <>
          {shouldShowSlot && (
            <CheckoutSlot
              className={checkoutUIRevampOrderSummary ? classes.slotBefore : classes.slotBeforeOld}
              slotId={SlotId.BeforeSummaryCheckoutSlot}
            />
          )}
          <CartSummary showSlots={shouldShowSlot} />
          {!checkoutUIRevampOrderSummary && <SecureCheckout />}
          {shouldShowSlot && (
            <CheckoutSlot
              className={checkoutUIRevampOrderSummary ? classes.slotAfter : classes.slotAfterOld}
              slotId={SlotId.AfterSummaryCheckoutSlot}
            />
          )}
        </>
      )}
    </div>
  );
};
